import React,{useState} from "react";
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';


import { withStyles } from '@mui/styles';
import logo from './assets/images/mtsolarlog.png'
import { APILogon } from './Api'



const ColorButton = withStyles((theme) => ({
    root: {
        marginTop: '10px!important',
        marginBottom: '10px!important',
        color: '#ffffff!important', 
        backgroundColor: '#1e3a5f!important',
        '&:hover': {
            backgroundColor: '#1e3a6f!important',
        },
    },
}))(Button);

const styles = {
    logonForm: {
        width: 300,
        height: 320,
        marginLeft: 'auto',
        marginRight: 'auto',
        border: '1px solid #1e3a5f',
        textAlign: 'center',
        marginTop: 100,
        paddingTop: 25
    },
    label: { marginTop: 20 },
    inputctl: { marginBottom: 10 },
    logo: { marginBottom: 20 }
}



const LogonScreen = (props) => {
    const id = props.flg_id ? props.flg_id : 0
    const classes = props.classes
    const [username, setUsername] = useState('')
    const [password, setPassword]  = useState('')
    const [error, setError ]= useState('')
    const [flg_id, setFLGId ]= useState(id)

    const DoLogon = async () => {
        //console.log("DoLogon clicked")
        if(username.length == 0 || password.length ===0) return

        try {
            const ret = await APILogon({email: username, password: password})
            //console.log(ret)
            if(ret.error) {
                setError(ret.error)
                return
            }
            if(ret.token && ret.user && ret.user.email === username){
                console.log('APILogon returned')
                console.log(ret)

                props.onChange({loggedon: true, flg_id, token: ret.token, user: ret.user.name, userid: ret.user["_id"], email: ret.user.email})
                return
            }
        } catch (err) {
            console.error('Login error:', err)
            setError('Cannot connect to server. Please ensure the backend API server is running at ' + process.env.REACT_APP_API_BASE_URL)
        }
    }

    return(
        <div className={classes.logonForm}>
            <img src={logo} alt='MT Solar' className={classes.logo} width="150" /><br/>
            <form>
            <InputLabel className={classes.label} id="lbluserName">Username</InputLabel>
            <Input id="username" name="username" value={username} onChange={(e) => setUsername(e.target.value)} labelid="lbluserName" autoComplete="username" />
            <InputLabel className={classes.label} id="lblPassword">Password</InputLabel>
            <Input id="password" name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} labelid="lblPassword" autoComplete="password" />
            {flg_id <= 0 && <>
                <InputLabel className={classes.label} id="lblFLGId">Customer Ref Number</InputLabel>
                <Input className={classes.inputctl} id="username" name="username" value={flg_id} onChange={(e) => setFLGId(e.target.value)} labelid="lbluserName" />
                </>
            }
            <br/>
            <ColorButton variant="contained" id='submitBtn' color="primary" onClick={DoLogon} >Logon</ColorButton>
            <p id='errmsg' >{error}</p>
            </form>
        </div>
    )
}

export default withStyles(styles)(LogonScreen)